import {ClearSessionQuery, ClearSessionMsg} from '../../autogenerated/ZoomBridge';
export default class ClearSession {
   constructor(clearBrowse, clearAll) {
    this.clearBrowse = clearBrowse;
    this.clearAll = clearAll;
   }

   run() {
    return new Promise((onSuccess, onFailure) => { 
     const query = new ClearSessionQuery();
     const msg = new ClearSessionMsg();
     msg.setUseBrowseSession(this.clearBrowse);
     msg.setClearAll(this.clearAll);
     query.message = msg;
     query.run().then(
       (resp) => {
           if(onSuccess)
            onSuccess(resp);
       },
       (error) => {
           if(onFailure)
            onFailure(error);
        }
     );
    });
   }  
}